export function isAamvaPayload(raw) {
  if (typeof raw !== 'string' || raw.length === 0) return false;
  return raw.startsWith('@') || raw.includes('ANSI ');
}

// DBB is MMDDCCYY on US (AAMVA v2+) cards and CCYYMMDD on Canadian / AAMVA v1 cards.
export function parseAamvaDob(raw) {
  if (typeof raw !== 'string') return null;
  const match = raw.match(/DBB(\d{8})/);
  if (!match) return null;
  const digits = match[1];

  const leading = parseInt(digits.substring(0, 2), 10);
  let year, month, day;
  if (leading >= 1 && leading <= 12) {
    month = leading;
    day = parseInt(digits.substring(2, 4), 10);
    year = parseInt(digits.substring(4, 8), 10);
  } else {
    year = parseInt(digits.substring(0, 4), 10);
    month = parseInt(digits.substring(4, 6), 10);
    day = parseInt(digits.substring(6, 8), 10);
  }

  if (!_isRealDate(year, month, day)) return null;
  return { year, month, day };
}

export function formatDobForEntry({ year, month, day }, dobEntryFormat) {
  const mm = String(month).padStart(2, '0');
  const dd = String(day).padStart(2, '0');
  const yyyy = String(year).padStart(4, '0');
  const yy = yyyy.slice(-2);
  switch (dobEntryFormat) {
    case 'MMDDYYYY': return `${mm}${dd}${yyyy}`;
    case 'DDMMYY': return `${dd}${mm}${yy}`;
    case 'DDMMYYYY': return `${dd}${mm}${yyyy}`;
    case 'MMDDYY':
    default:
      return `${mm}${dd}${yy}`;
  }
}

function _isRealDate(year, month, day) {
  if (!year || year < 1900) return false;
  if (month < 1 || month > 12) return false;
  if (day < 1) return false;
  const daysInMonth = new Date(year, month, 0).getDate();
  return day <= daysInMonth;
}
